export default "__VITE_ASSET__NFMCSmxe__"